import React from "react";
import { Default } from "../../components/default/Default";
import DownloadOutputTable from "./DownloadOutputTable";
import { useParams, useNavigate, Link } from "react-router-dom";

const DownloadOutput = () => {
  const params = useParams();
  const navigate = useNavigate();

  return (
    <Default>
      <div className="mca-content">
        <button
          type="button"
          className="mca-btn mca-btn--ghost mca-btn--sm"
          onClick={() => navigate(-1)}
          style={{ marginBottom: "12px", paddingLeft: "8px" }}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="m15 6-6 6 6 6" />
          </svg>
          <span className="mca-btn__label">Back</span>
        </button>

        <nav className="mca-crumbs" style={{ marginBottom: "14px" }}>
          <Link to="/collections">Collections</Link>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: "13px", height: "13px" }}>
            <path d="m9 6 6 6-6 6" />
          </svg>
          <span className="current">Downloads</span>
        </nav>

        <div style={{ marginBottom: "20px" }}>
          <h1 style={{ fontSize: "26px", fontWeight: "700", letterSpacing: "-0.02em" }}>Download results</h1>
          <p style={{ color: "var(--mca-muted)", fontSize: "14px", margin: "6px 0 0" }}>
            Each completed run produces page files and a full ZIP archive.
          </p>
        </div>

        <DownloadOutputTable collectionId={params.id} />
      </div>
    </Default>
  );
};

export default DownloadOutput;
